/* eslint-disable */
import Vue from 'vue'
if(!Function.bind) {

  Function.prototype.update = function(array, args) {
    var arrayLength = array.length, length = args.length;
      while (length--)
        array[arrayLength + length] = args[length];
      return array;
  }
  Function.prototype.merge = function(array, args) {
      array = Array.prototype.slice.call(array, 0);
      return Function.update(array, args);
  }

  Function.prototype.bind = function(context) {
    if (arguments.length < 2 && typeof arguments[0] === "undefined") return this;
    var __method = this, args = Array.prototype.slice.call(arguments, 1);
    return function() {
      var a = Function.merge(args, arguments);
      return __method.apply(context, a);
    }
  }

}
/**
 * 连续count个当前字符串连接
 * @param {int} count
 * @returns {string}
 */
String.prototype.times = function(count) {
    return count < 1 ? '' : new Array(count + 1).join(this);
}
/**
	 * 字符串左补0到指定位数
	 * @param {int} width
	 * @returns {string}
	 */
 String.prototype.leftPadZero = function( width ) {
  var pad = width - this.length;
  if ( pad > 0 ){
    return ("0".times(pad) + this);
  }else{
    return this;
  }
};

String.prototype.blank = function() {
    return /^\s*$/.test(this);
}

/**
 * 将日期对象根据指定的格式格式化为字符串
 * @param {string} format 日期格式
 * @returns {string}
 */
Date.prototype.format = function( format ){
  if ( !format ){
    format = $.lily.format.DATE_FORMAT;
  }
  return format.replace(
    Vue.prototype.$_format.REGEXP_DATE,
    function(str){
      switch ( str.toLowerCase() ){
        case 'yyyy': return this.getFullYear();
        case 'mm': return (this.getMonth() + 1).toString().leftPadZero(2);
        case 'dd': return this.getDate().toString().leftPadZero(2);
        case 'hh': return this.getHours().toString().leftPadZero(2);
        case 'mi': return this.getMinutes().toString().leftPadZero(2);
        case 'ss': return this.getSeconds().toString().leftPadZero(2);
        case 'ms': return this.getMilliseconds().toString().leftPadZero(3);
      }
    }.bind(this)
  );
};

/**
 * 比较日期是否为同一天
 * @param {Date} compareDate 要比较的日期
 * @returns {boolean}
 */
Date.prototype.isSameDay = function( compareDate ) {
  return ( this.getFullYear() === compareDate.getFullYear() && this.getMonth() === compareDate.getMonth() && this.getDate() === compareDate.getDate() );
};
/**
	 * 比较日期大小,如果compareDate较大则返回true
	 * @param {Date} compareDate 要比较的日期
	 * @returns {boolean}
	 */
 Date.prototype.isBefore= function( compareDate ) {
  var sDate = this;
  var eDate = compareDate;

  var flag = true;

  if (flag && sDate.getFullYear() > eDate.getFullYear()) {
    flag = false;
  }
  if (flag && sDate.getFullYear() == eDate.getFullYear()
      && sDate.getMonth() > eDate.getMonth()) {
    flag = false;
  }
  if (flag && sDate.getFullYear() == eDate.getFullYear()
      && sDate.getMonth() == eDate.getMonth()
      && sDate.getDate() > eDate.getDate()) {
    flag = false;
  }
  return flag;
};
/**
 * 取得当前日期的下一天
 * @returns {Date}
 */
Date.prototype.nextDay = function( ) {
  return new Date(Date.parse(this)+86400000);
};
Date.prototype.prevDay = function(days) {
  return new Date(Date.parse(this)-86400000*parseInt(days));
};
